import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../components/api/axiosInstance";
import WebsiteLeadsPanel from "../components/WebsiteLeadsPanel";
import WebsiteFormKeys from "../components/WebsiteFormKeys";
import { FaGlobe } from "react-icons/fa";
import useActiveTenants from "../hooks/useActiveTenants";
import "../assets/css/MyDay.css";
import "../assets/css/PageHeading.css";

async function loadLeadStatuses() {
  const res = await axiosInstance.get("/lead-statuses");
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
}

const TABS = [
  { id: "leads", label: "Leads" },
  { id: "keys", label: "Form Keys" },
];

const TENANT_STORAGE_KEY = "cloudOffice_websiteLeads_tenantId";

function readStoredTenant() {
  try {
    return sessionStorage.getItem(TENANT_STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

function WebsiteLeads() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("leads");
  const [tenantId, setTenantId] = useState(readStoredTenant);
  const tenants = useActiveTenants();

  const changeTenant = (next) => {
    setTenantId(next);
    try {
      if (next) sessionStorage.setItem(TENANT_STORAGE_KEY, next);
      else sessionStorage.removeItem(TENANT_STORAGE_KEY);
    } catch {
      /* storage unavailable */
    }
  };

  return (
    <div className="p-2 p-md-3 wl-page">
      <div className="co-page-head">
        <h2 className="co-page-head__title">Website Leads</h2>
      </div>
      <div className="wl-page-card">
        <div className="dmcal-filters wl-client-filters">
          <label className="dmcal-field">
            <select
              value={tenantId}
              onChange={(e) => changeTenant(e.target.value)}
              aria-label="Client"
            >
              <option value="">Select a client…</option>
              {tenants.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="wl-page-select-wrap">
          <select
            className="wl-page-select"
            value={tab}
            onChange={(e) => setTab(e.target.value)}
            aria-label="Website leads section"
          >
            {TABS.map((t) => (
              <option key={t.id} value={t.id}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
        <div className="wl-page-tabs" role="tablist" aria-label="Website leads sections">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              className={`wl-page-tab${tab === t.id ? " is-active" : ""}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
        {!tenantId ? (
          <div className="dmcal-empty">
            <div className="dmcal-empty__icon" aria-hidden="true">
              <FaGlobe />
            </div>
            <div className="dmcal-empty__title">No client selected</div>
            <p className="dmcal-empty__text">Choose a client above to see its website leads and form keys.</p>
          </div>
        ) : tab === "leads" ? (
          <WebsiteLeadsPanel
            key={tenantId}
            apiBase="/website-leads"
            tenantId={tenantId}
            loadStatuses={loadLeadStatuses}
            onOpenLead={(leadId) => navigate(`/realestate-leads/${leadId}/view`)}
          />
        ) : (
          <WebsiteFormKeys key={tenantId} tenantId={tenantId} />
        )}
      </div>
    </div>
  );
}

export default WebsiteLeads;
